import { useTranslator } from '@jutro/locale';
import messages from './MLReadableErrorUtil.messages.js';

function MLReadableErrorUtil() {
    const translator = useTranslator();

    // map the exact error string or regex to a message you wish to replace it with
    const messageMap = new Map([
        [/[a-zA-Z]+:[0-9]+\s=\s[0-9]+\/[0-9]+\s\[.*\s-\s[0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]{1,3})?,[0-9]+]/, messages.concurrentDataChange],
        [/Cannot take action "[\s\S]*" for the following reasons:[\s\S]*has preemptions[\s\S]*/, messages.policyChangePreemption]
    ]);

    const getReadableError = (inputKey) => {
        for (const key of messageMap.keys()) {
            const hasMatch = (typeof key === 'string') ? (key === inputKey) : key.test(inputKey);
            if (hasMatch) {
                return messageMap.get(key);
            }
        }
        return undefined;
    };

    const replaceUnreadableError = (errorMessage) => {
        const readableError = getReadableError(errorMessage);
        if (readableError) {
            if (readableError === messages.policyChangePreemption && errorMessage.includes('has preemptions:')) {
                const transactionNumber = errorMessage.split('has preemptions:')[1].split('.')[0];
                return translator(readableError, {transactionNumber});
            }
            return translator(readableError);
        }
        return errorMessage;
    };

    return {
        replaceUnreadableError
    };
}

export default MLReadableErrorUtil;